import { useNavigate } from 'react-router-dom';
import { FlexCell, FlexRow } from '@epam/promo';

import { StatisticsCard, StatisticsTasks } from 'components/statistics';
import { useStatisticsGetAllQuery } from 'hooks';
import css from './StatisticsPage.module.scss';

export const StatisticsPage = () => {
  const navigate = useNavigate();
  const {
    isLoading,
    activeUsers,
    amountOfRegistrations,
    skippedTasks,
    failedTasks,
  } = useStatisticsGetAllQuery();

  const onTaskClick = (id: string) => {
    navigate(`/tasks/${id}`);
  };

  return (
    <FlexRow cx={css.page__container}>
      <FlexCell>
        <StatisticsTasks
          isLoading={isLoading}
          range="All time"
          tasks={skippedTasks}
          title="Skipped tasks"
          tooltip={`On this tab you can see top 10 skipped tasks.
        On the right side of each line you will find amount of clicks on "Remind me later button".
        Our goal is to decrease amount of skips and write funny and valuable tasks.`}
          onTaskClick={onTaskClick}
        />
      </FlexCell>
      <FlexCell cx={css['periodical-statistics__container']}>
        <StatisticsCard
          isLoading={isLoading}
          title="Number of registrations"
          tooltip={`Number of registrations during the period:
          Monthly for last month
          Weekly for last week
          Daily for yesterday`}
          userStatistics={amountOfRegistrations}
        />
        <StatisticsCard
          isLoading={isLoading}
          title="Amount of active users"
          tooltip={`Amount of active users is amount of users who completed at least one task during the period:
          Monthly for last month,
          Weekly for last week,
          Daily for yesterday`}
          userStatistics={activeUsers}
        />
      </FlexCell>
      <FlexCell>
        <StatisticsTasks
          isFailed
          isLoading={isLoading}
          range="All time"
          tasks={failedTasks}
          title="Failed validations"
          tooltip={`On this tab you can see top 10 failed tasks. On the right side of each line you will find amount
          of failed validations, when user gives wrong answer. Our goal is to decrease amount of fails and write
          funny and easy tasks`}
          onTaskClick={onTaskClick}
        />
      </FlexCell>
      <div className={css.break} />
    </FlexRow>
  );
};
